<template>
  <b-row>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template #header>
            {{ category.name }}
            <b-button
              class="float-right"
              variant="primary"
              size="sm"
              @click="onSave"
              >Salvar</b-button
            >
          </template>
          <b-card-body>
            <b-table
              :hover="true"
              :striped="true"
              :bordered="true"
              :small="false"
              :fixed="false"
              responsive="sm"
              :items="requirements"
              :fields="headers"
            >
              <template #cell(id)="cell">
                {{ cell.item._id }}
              </template>
              <template #cell(group)="cell">
                {{ cell.value.name }}
              </template>
              <template #cell(status)="cell">
                <b-form-select
                  v-model="companyStatus[cell.item._id]"
                  :options="options"
                ></b-form-select>
              </template>
            </b-table>
          </b-card-body>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import {
  getCompanyRequirements,
  updateCompanyRequirements,
  getRequirementCategory,
} from "../../api/requirements";
import { mapGetters } from "vuex";

export default {
  name: "ConformityCategoryList",
  props: {
    id: {
      type: String,
      default: null,
    },
    companyId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      company: { _id: this.companyId },
      category: {},
      options: [
        { value: null, text: "Por favor selecione uma opção", disabled: true },
        { value: 1, text: "Aguardando" },
        { value: 2, text: "Em andamento" },
        { value: 3, text: "Concluído" },
        { value: 4, text: "Não se aplica" },
      ],
      headers: [
        { key: "id", label: "#", thStyle: { width: "30px !important" } },
        {
          key: "group",
          label: "Grupo do requisito",
          thStyle: { width: "150px !important" },
        },
        { key: "text", label: "O que?" },
        { key: "description", label: "Porquê?" },
        {
          key: "status",
          label: "Status",
          thStyle: { width: "185px !important" },
        },
      ],
      requirements: [],
      data: {
        docs: [],
        total: 0,
        page: 1,
        pages: 0,
        limit: 10,
      },
      companyStatus: {},
    };
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  async created() {
    if (!this.companyId) {
      this.company._id = this.profile.company;
    }
    const response = await getRequirementCategory(this.id);
    this.category = response.data;
    this.loadData();
  },
  methods: {
    async onSave() {
      try {
        await updateCompanyRequirements(
          this.company._id,
          this.category._id,
          this.companyStatus
        );
        this.$bvToast.toast("Requisitos atualizados com sucesso!", {
          title: "Sucesso",
          toastClass: "custom-toast custom-toast-success",
          variant: "light",
          solid: true,
          autoHideDelay: 5000,
          noCloseButton: false,
        });
      } catch (error) {
        if (error.response.status === 403 || error.response.status === 404) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
      }
    },

    async loadData() {
      const response = await getCompanyRequirements(
        this.company._id,
        this.category._id
      );
      const { requirements, companyStatus } = response.data;
      this.requirements = requirements;
      this.companyStatus = companyStatus;
    },
  },
};
</script>
